const Ajv = require('ajv');
const ajv = new Ajv({ allErrors: true });
import appCtxSvc from 'js/appCtxService';
import { get, isNil } from 'lodash';
import eventBus from 'js/eventBus';
import AwHttpService from 'js/awHttpService';
import browserUtils from 'js/browserUtils';
const DES_CUSTOM_COMMANDS_INVALID = 'des-custom-commands.invalid';
const DES_CUSTOM_COMMANDS_VALID = 'des-custom-commands.valid';

const customCommandsSchema = {
    "type": "object",
    "properties": {
        "commands": {
            "type": "array",
            "items": {
                "$ref": "#/definitions/Command"
            }
        }
    },
    "definitions": {
        "Command": {
            "type": "object",
            "properties": {
                "id": {
                    "type": "string"
                },
                "iconUrl": {
                    "type": "string"
                },
                "title": {
                    "type": "object",
                    "$ref": "#/definitions/Locale"
                },
                "toolTip": {
                    "type": "object",
                    "$ref": "#/definitions/Locale"
                },
                "eventId": {
                    "type": "string"
                },
                "parentId": {
                    "type": "string"
                },
                "isGroup": {
                    "type": "boolean"
                }
            },
            "required": [
                "id",
                "iconUrl",
                "title",
                "eventId"
            ],
            "additionalProperties": false
        },
        "Locale": {
            "type": "object",
            "properties": {
                "en_US": {
                    "type": "string"
                },
                "cs_CZ": {
                    "type": "string"
                },
                "de": {
                    "type": "string"
                },
                "es": {
                    "type": "string"
                },
                "fr": {
                    "type": "string"
                },
                "it": {
                    "type": "string"
                },
                "ja_JP": {
                    "type": "string"
                },
                "ko_KR": {
                    "type": "string"
                },
                "pl_PL": {
                    "type": "string"
                },
                "pt_BR": {
                    "type": "string"
                },
                "ru_RU": {
                    "type": "string"
                },
                "zh_CN": {
                    "type": "string"
                },
                "zh_TW": {
                    "type": "string"
                }
            },
            "required": [
                "en_US"
            ],
            "additionalProperties": false
        }
    }
}
/**
 * Below globally declared arrays are used to hold data from each level custom command.
 */
let levelOneCommands = [];
let levelTwoCommands = [];
let levelThreeCommands = [];
let groupCommandStatus = false;
let count = 0;

/**
 * Function validates custom command data returned by extension src.
 * @param {*} extensionSrc The extensionSrc is the relative URL which holds custom command data.
 */
const validateExtensionSrc = (extensionSrc) => {
    const validate = ajv.compile(customCommandsSchema);
    let valid = false;
    if (extensionSrc) {
        AwHttpService.instance.get(browserUtils.getBaseURL() + extensionSrc).then((commands) => {
            const commandsData = commands.data;
            valid = validate(commandsData);
            appCtxSvc.registerCtx('customCommadsInput', commandsData);
            appCtxSvc.registerCtx('customCommadsValidData',);
            if (valid) {
                console.log('Custom commands input is Valid!');
                appCtxSvc.registerCtx('customCommadsValidData', commandsData);
                eventBus.publish(DES_CUSTOM_COMMANDS_VALID);
            }
            else {
                console.log('Invalid: ' + ajv.errorsText(validate.errors));
                appCtxSvc.registerCtx('customCommadsErrors', ajv.errorsText(validate.errors));
                eventBus.publish(DES_CUSTOM_COMMANDS_INVALID);
            }
        });
    }

}

const removeDuplicates = (arr) => {
    return arr.filter((item,
        index) => arr.indexOf(item) === index);
}

const invalidCustomCommandNotification = (errorData, customCommandInput, vmo) => {
    let invalidCommandError = [];
    invalidCommandError = errorData.split(', ');
    //remove duplicate data
    invalidCommandError = removeDuplicates(invalidCommandError);
    let invalidCustomCommandError = "In custom command input '";
    let titleFlag = false;
    // Create invalidCommandError array in such way that we always get title at 14th index
    invalidCommandError.forEach(error => {
        if (customCommandInput.commands[error[14]].title) {
            invalidCustomCommandError = invalidCustomCommandError + customCommandInput.commands[error[14]].title.en_US + "' command " + error.substring(17,);
        }
        else {
            titleFlag = true;
        }
    });

    if (titleFlag) {
        invalidCustomCommandError = vmo.i18n.customCommandErrorMsg;
    }
    return { invalidCustomCommandError };
}

/**
 * Function publishes event after click on custom command and decide whether to display child commands.
 */
const handleCustomCommandClick = (e, eventId, isGroupCommand) => {

    // Group command check, if it is group command then render first child command.
    if (isGroupCommand) {
        const xPositionOfFirstChild = e.clientX - 200;
        const yPositionOfFirstChild = e.clientY;
        const firstChildElementStyle = document.getElementsByClassName('des-custom-command-first-child')[0].style;
        count++;
        firstChildElementStyle.position = "fixed";
        if (count < 2) {
            firstChildElementStyle.top = `${yPositionOfFirstChild}px`;
            firstChildElementStyle.left = `${xPositionOfFirstChild}px`;
        }
        firstChildElementStyle.visibility = 'visible';
    }
    // Group command check, if it is group command then render second child command.
    if (groupCommandStatus && isGroupCommand) {

        const xPositionOfSecondChild = e.clientX - 200;
        const yPositionOfSecondChild = e.clientY;
        const secondChildElementStyle = document.getElementsByClassName('des-custom-command-second-child')[0].style;
        secondChildElementStyle.position = 'fixed';
        secondChildElementStyle.top = `${yPositionOfSecondChild}px`;
        secondChildElementStyle.left = `${xPositionOfSecondChild}px`;
        secondChildElementStyle.visibility = 'visible';

    }
    const commandLength = document.getElementsByClassName('aw-popup-command-bar').length;
    if (!isGroupCommand) {
        for (let i = 0; i < commandLength; i++) {
            document.getElementsByClassName('aw-popup-command-bar')[i].style.display = 'none';
        }
    }
    groupCommandStatus = isGroupCommand;
    const commandTitle = eventId;
    eventBus.publish('customCommandSelected', {
        eventData: commandTitle,
    });
}

const storeSelectedObjectData = (selectedObjectData) => {
    appCtxSvc.registerCtx('selectedCustomCommandData', selectedObjectData);
};

/**
 * Function seperates each level command data
 * @param {*} commands Commands array which holds valid custom command data
 */
const createChildCommandData = (commands) => {
    levelOneCommands = [];
    levelTwoCommands = [];
    levelThreeCommands = [];
    const childCommands = [];

    commands.forEach((command) => {
        if (!isNil(command.parentId)) {
            childCommands.push(command);
        }
        else {
            levelOneCommands.push(command);
        }
    });
    if (childCommands.length > 0) {
        const groupCommand = childCommands.find(command => command.isGroup);
        childCommands.forEach((command) => {
            if (command.parentId === groupCommand.id) {
                levelThreeCommands.push(command);
            }
            else {
                levelTwoCommands.push(command);
            }
        });
    }
}

const getCommandList = (commandscehma) => {
    let usrlang = navigator.language;
    return commandscehma.map((desCustomCmd, desKey) => {
        if (!desCustomCmd.title.hasOwnProperty(usrlang)) {
            usrlang = 'en_US';
        }
        const eventId = get(desCustomCmd, 'eventId');
        const title = get(desCustomCmd, `title.${usrlang}`);
        const isGroupCommand = get(desCustomCmd, 'isGroup');
        return (
            <>
                <li id={desCustomCmd.id} className='sw-aria-border aw-widgets-cellListItem aw-widgets-cellTop aw-hierarchical-popup'
                    onClick={e => handleCustomCommandClick(e, eventId, isGroupCommand)}>
                    <div className='aw-popup-cellContentContainer-custom'>
                        <span className='aw-icon undefined aw-widget-thumbnail'>
                            <img src={desCustomCmd.iconUrl} width={24} height={24}></img>
                        </span>{title}</div>
                    <div className='aw-widgets-groupCommandStack' style={{ display: desCustomCmd.isGroup ? 'inline' : 'none' }}>
                        <span iconid='miscDownArrow_uxRefresh' className='aw-icon' icon-id='miscDownArrow_uxRefresh'>
                            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'><path className='aw-theme-iconOutline' fill='#464646' d='M2 4l4 4 4-4z'></path></svg>
                        </span>
                    </div>
                </li>
                {(desKey !== commandscehma.length - 1) && <hr className='des-custom-command-separator'></hr>}
            </>
        )
    });
};

const renderChildCommands = (childCommands) => {
    return (
        <div className='sw-popup'>
            <div className='sw-popup-layout aw-layout-popup'>
                <div className='sw-popup-contentContainer'>
                    <div className='aw-popup-command-bar'>
                        {getCommandList(childCommands)}
                    </div>
                </div>
            </div>
        </div>
    )
}

const renderCustomCommands = () => {
    groupCommandStatus = false;
    count = 0;
    return (
        <>
            <div className='des-custom-commands'>
                <div className='aw-popup-command-bar'>
                    {getCommandList(levelOneCommands)}
                </div>
                <div className='des-custom-command-first-child'>
                    {renderChildCommands(levelTwoCommands)}
                </div>
                <div className='des-custom-command-second-child'>
                    {renderChildCommands(levelThreeCommands)}
                </div>
            </div>
        </>
    );
}

export {
    validateExtensionSrc,
    renderCustomCommands,
    invalidCustomCommandNotification,
    storeSelectedObjectData,
    createChildCommandData
};
